import React, { useState, useEffect } from 'react';
import { Badge, Menu, Dropdown } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { caseNotesService } from '../../services/caseNotesService';
import { CaseNotesDTO } from "../../models/CaseNotes";
import { eventBus } from '../../eventBus';
import { routes } from '../../routes';


const NotificationMenu = () => {
  const [caseNotes, setCaseNotes] = useState<CaseNotesDTO[]>([]);

  const fetchCaseNotes = async () => {
    try {
      const response = await caseNotesService.caseNoteNotRead();
      setCaseNotes(response);
    } catch (error) {
      console.error('Error fetching case notes:', error);
    }
  };

  useEffect(() => {
    fetchCaseNotes();
    const interval = setInterval(fetchCaseNotes, 30000);

    const handleNoteRead = () => {
      fetchCaseNotes();
    };

    eventBus.on('noteRead', handleNoteRead);

    return () => {
      clearInterval(interval);
      eventBus.off('noteRead', handleNoteRead);
    };
  }, []);

  const menu = (
    <Menu>
      {caseNotes.map((note) => (
        <Menu.Item key={note.id}>
          <Link to=
          {`${routes.CASE_DETAILS.replace( ":id", note.caseDetail?.id?.toString()!)}`}
          >
            {"Caso "}{note.caseDetail?.id}-{note.noteContent?.substring(0, 30)}...
          </Link>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} placement="bottomRight">
      <Badge count={caseNotes.length} style={{ marginRight: 24 }}>
        <BellOutlined style={{ fontSize: 20 }} />
      </Badge>
    </Dropdown>
  );
};

export default NotificationMenu;